export const actions = {
    ADD_LINK_ACTIVITY: 'ADD_LINK_ACTIVITY',
    ADD_LINK_SET_ACTIVITY: 'ADD_LINK_SET_ACTIVITY',

    ADD_LINK_UPDATE_ACTIVITY: 'ADD_LINK_UPDATE_ACTIVITY',

    DELETE_LINK_ACTIVITY:'DELETE_LINK_ACTIVITY',
    DELETE_LINK_SET_ACTIVITY:'DELETE_LINK_SET_ACTIVITY',

    SET_LINK_DATA_DEFAULT:'SET_LINK_DATA_DEFAULT'
};